// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
class ProductStartTempRecord extends VerofreshRecord {
}

export default ProductStartTempRecord
